import type { ReturnsProductDetailsResponseVariantInfo } from '@itsrever/rever-api'

export const hasVariantStock = (
  variant: ReturnsProductDetailsResponseVariantInfo,
  requiredQuantity = 1
) => {
  return (
    !variant.is_inventory_enabled ||
    (variant.inventory_quantity &&
      variant.inventory_quantity >= requiredQuantity)
  )
}
